import React from 'react'
import { CheckCircleFilled } from '@ant-design/icons'

type CheckBoxWithTextProps = React.HTMLAttributes<HTMLDivElement> & {
    title?: string;
    textColor?: string
    iconColor?: string
}

const CheckBoxWithText = ({ title="Email Verification", textColor="#808080", iconColor="#808080", ...props}: CheckBoxWithTextProps) => {
    const {className, ...newProps } = {...props}
  return (
    <div className={`flex items-center ${className}`} {...newProps}>
        <div className="self-center" >
            <CheckCircleFilled style={{color: iconColor, fontSize: 22 }}  />
        </div>
        <div>
            <p className="text-base font-poppins font-semibold text-grayPrimary p-0 pl-2 m-0" style={{color: textColor}}>
                {title}
            </p>
        </div>
    </div>
  )
}

export default CheckBoxWithText
